/** Shown (by CSS) while today's Vault page is still loading - owner 11-04: "a loading skeleton, smooth, fits the layout". */
export function VaultSkeleton() {
  return (
    <div className="v2-vault-skel" role="status" aria-label="Loading your vault">
      <h1 className="v2-vault-skel-title">Your Vault</h1>
      <div className="v2-vault-skel-tabs"><span className="v2-skel" /><span className="v2-skel" /><span className="v2-skel" /></div>
      <div className="v2-vault-skel-grid">{Array.from({ length: 6 }, (_, i) => <span key={i} className="v2-skel v2-skel-tile" />)}</div>
    </div>
  )
}
